import { render, staticRenderFns } from "./SessionAuthorizationList.vue?vue&type=template&id=046ce806"
import script from "./SessionAuthorizationList.vue?vue&type=script&lang=js"
export * from "./SessionAuthorizationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports